import { FC } from 'react';
import { getErrorReason, getIsWarningIconEnabled } from 'utils/common';
import {
  APPOINTMENT_STATUS,
  ERROR_LABEL,
  ERROR_REASON,
  PMS_TYPE,
} from 'utils/constants';

interface AppointmentDetailStatusProps {
  appointment: any;
}

const {
  NEW: { KEY: newStatus },
  ACCEPTED: { KEY: acceptedStatus },
  CANCELLED: { KEY: cancelledStatus },
  COMPLETED: { KEY: completedStatus },
  MISSED: { KEY: missedStatus },
} = APPOINTMENT_STATUS;

const getLabel = (appointment: any) => {
  if (appointment.pmsType !== PMS_TYPE.FIRST_IN) {
    return null;
  }

  const errorReason = appointment ? getErrorReason(appointment) : null;

  const isWarningIconEnabled = appointment
    ? getIsWarningIconEnabled(appointment)
    : null;

  if (isWarningIconEnabled) {
    return 'PMS Sync Pending';
  } else if (errorReason) {
    return ERROR_LABEL[errorReason] || 'Error';
  } else if (appointment.status === newStatus) {
    return 'New Appointment Request';
  } else if (appointment.status === acceptedStatus) {
    return 'Accepted';
  } else if (appointment.status === completedStatus) {
    return 'Completed';
  } else if (appointment.status === missedStatus) {
    return 'Missed';
  } else if (appointment.status === cancelledStatus) {
    return 'Cancelled';
  }
};

const getClassName = (appointment: any) => {
  let className =
    'flex justify-center items-center px-1 py-0.2 border-0.3 rounded-full text-12 leading-[1.8rem] ';

  const isWarningIconEnabled = appointment
    ? getIsWarningIconEnabled(appointment)
    : null;

  const errorReason = getErrorReason(appointment);

  if (
    isWarningIconEnabled ||
    errorReason === ERROR_REASON.PATIENT_NEED_ADD_TO_FAMILY
  ) {
    className += 'text-[#FFC656] bg-[#FFF9EE]';
  } else if (errorReason) {
    className += 'text-[#D31759] bg-[#FFF2F3]';
  } else if (appointment.status === newStatus) {
    className += 'text-magenta bg-[#FFF6FF]';
  } else if (appointment.status === acceptedStatus) {
    className += 'text-[#47B2AD] bg-[#E1F7F6]';
  } else if (appointment.status === completedStatus) {
    className += 'text-[#4D97E1] bg-[#F4FAFF]';
  } else if (appointment.status === missedStatus) {
    className += 'text-[#FFC656] bg-[#FFF9EE]';
  } else if (appointment.status === cancelledStatus) {
    className += 'text-[#51169D] bg-[#F8F8FF]';
  }
  return className;
};

const AppointmentDetailStatus: FC<AppointmentDetailStatusProps> = ({
  appointment,
}) => {
  const label = getLabel(appointment);

  if (label) {
    return (
      <div className="flex flex-row gap-x-1">
        <div className={getClassName(appointment)}>{label}</div>
        {appointment.awaitingAppointmentsByPatient?.length !== 0 && (
          <div className="flex justify-center items-center px-1 py-0.2 border-0.3 rounded-full text-12 leading-[1.8rem] text-[#FFC656] bg-[#FFF9EE]">
            Appointment Conflict
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default AppointmentDetailStatus;
